module.exports = __webpack_public_path__ + "assets/img/camera.46cb4eaf.svg";